// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ColisseumView_Wrapper__vfxZH"};